export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/common-area/index/resources/computed.js